/* eslint-disable no-shadow */
import TagManager from "react-gtm-module";

export enum TrackingEvents {
  AutoPayToggled = "auto_pay_toggled",
}

export function trackEvent(
  eventName: string,
  params: Record<string, string | number | boolean> = {}
) {
  return TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...params,
    },
  });
}
